function extractNumberAndLabel(str) {
  const trimmed = str.trim();
  const match = trimmed.match(/(\d+)(.*)/); // Extracts number and remainder
  if (match) {
    return [parseInt(match[1], 10), match[2].trim()];
  }
  return [Infinity, '']; // If no number found, sort to end
}

export function sortByNumericPrefix(data) {
  const [header, ...rows] = data;

  const sorted = rows.sort((a, b) => {
    const [numA, labelA] = extractNumberAndLabel(a[0]);
    const [numB, labelB] = extractNumberAndLabel(b[0]);

    if (numA !== numB) {
      return numA - numB;
    }
    return labelA.localeCompare(labelB);
  });

  return [header, ...sorted];
}
